// import React, { useEffect, useState } from 'react';
// import TradeCard from './../components/TradeCard';
// import config from '../config';
// import './../Trades.css';

// const Trades = () => {
//   const [trades, setTrades] = useState([]);

//   useEffect(() => {
//     const fetchTrades = async () => {
//       try {
//         const response = await fetch(`${config.API_BASE_URL}getOrders`);
//         const data = await response.json();
//         setTrades(data);
//       } catch (error) {
//         console.error('Error fetching trades:', error);
//       }
//     };

//     fetchTrades();
//   }, []);

//   return (
//     <div className="trades-page">
//       {trades.map((trade) => (
//         <TradeCard key={trade.orderId} trade={trade} />
//       ))}
//     </div>
//   );
// };

// export default Trades;





// import React, { useEffect, useState } from 'react';
// import TradeCard from './../components/TradeCard';
// import config from '../config';
// import './../Trades.css';

// const Trades = () => {
//   const [trades, setTrades] = useState([]);
//   const user_id = '689239'; // Replace with your actual user_id

//   useEffect(() => {
//     const fetchTrades = async () => {
//       try {
//         const response = await fetch(`${config.API_BASE_URL}getOrders`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({ user_id }),
//         });
//         const data = await response.json();
//         setTrades(data); // Assuming data is an array of trades
//       } catch (error) {
//         console.error('Error fetching trades:', error);
//       }
//     };

//     fetchTrades();
//   }, [user_id]);

//   return (
//     <div className="trades-page">
//       {trades.map((trade) => (
//         <TradeCard key={trade.orderId} trade={trade} />
//       ))}
//     </div>
//   );
// };

// export default Trades;




// import React, { useContext } from 'react';
// import TradeCard from './../components/TradeCard';
// import { WebSocketContext } from "../WebSocketContext";

// const Trades = () => {
//   const { trades, stocks, refreshTradesAndPortfolio } = useContext(WebSocketContext);

//   const handleRefresh = () => {
//     refreshTradesAndPortfolio("trades");
//   };

//   return (
//     <div className="trades-page">
//       <button onClick={handleRefresh}>Refresh Trades</button>
//       {/* Render trades using stocks from WebSocketContext */}
//       {trades.map(trade => (
//         <TradeCard 
//           key={trade.tradeId} 
//           stock={stocks[trade.symbol]} // Access real-time stock data from WebSocketContext
//           trade={trade} 
//         />
//       ))}
//     </div>
//   );
// }

// export default Trades;




import React, { useContext, useState, useEffect } from 'react';
import TradeCard from './../components/TradeCard';
import { WebSocketContext } from "../WebSocketContext";
import { useTheme } from '../contexts/ThemeContext';
import './../Trades.css'; // Assuming you have a CSS file for styles
import { Refresh } from '@mui/icons-material';

const Trades = () => {
  const { trades, stocks, refreshTradesAndPortfolio } = useContext(WebSocketContext);
  const { isDarkMode } = useTheme();
  const [filter, setFilter] = useState('executed');

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleRefresh = () => {
    alert("refreshing trades");
    refreshTradesAndPortfolio("both");
  };

  // Log when Trades page is opened
  // useEffect(() => {
  //   console.log("Trades page opened");
  // }, []);

  const filteredTrades = trades.filter(trade => {
    if (filter === 'executed') return trade.orderStatus == "2" || trade.orderStatus == "3";
    if (filter === 'limit') return trade.orderStatus == "1" || trade.orderStatus == "4";
    return true;
  });

  return (
    <div className={`trades-page ${isDarkMode ? 'dark-theme' : 'light-theme'}`} data-theme={isDarkMode ? 'dark' : 'light'}>
      <div className="filter-tabs">
        <button
          type="button"
          className={`filter-tab${filter === 'executed' ? ' active' : ''}`}
          onClick={() => setFilter('executed')}
        >
          Executed
        </button>
        <button
          type="button"
          className={`filter-tab${filter === 'limit' ? ' active' : ''}`}
          onClick={() => setFilter('limit')}
        >
          Limit
        </button>
      </div>
      <button className="refresh-button" onClick={handleRefresh}><Refresh /></button>
      {/* Render trades using stocks from WebSocketContext */}
      {filteredTrades.length === 0 ? (
        <div className="trades-empty-state">
          <h3>No Trades Found</h3>
          <p>You don't have any {filter} trades at the moment.</p>
        </div>
      ) : (
        filteredTrades.map(trade => (
          <TradeCard 
            key={trade.orderId} 
            refreshTradesAndPortfolio={refreshTradesAndPortfolio}
            stock={stocks[trade.symbol]} // Access real-time stock data from WebSocketContext
            trade={trade} 
            isDarkMode={isDarkMode}
          />
        ))
      )}
    </div>
  );
}

export default Trades;

